// 全局组件
import Vue from "vue";
import noLogin from "./NoLoginAll.vue";

const PopupBox = Vue.extend(noLogin);

noLogin.install = function(data) {
  let instance = new PopupBox({
    data
  }).$mount();

  document.body.appendChild(instance.$el);

  Vue.nextTick(() => {
    instance.show();
  });
};

export default noLogin;



// WEBPACK FOOTER //
// ./src/components/popup/index.js